import { getCookie, getSelectedCity } from "../utils";
export class Cart {
    constructor() {
        this.key = 'cart-id';
    }
    set cartId(val) {
        localStorage.setItem(this.key, val.toString());
    }
    get cartId() {
        const val = localStorage.getItem(this.key);
        if (val) {
            return +val;
        }
        return null;
    }
    overwriteCart() {
        const params = new URLSearchParams(window.location.search);
        const cartId = +Object.fromEntries(params.entries())['carrito'];
        if (!!cartId) {
            localStorage.setItem(this.key, `${cartId}`);
        }
    }
    async init() {
        this.overwriteCart();
        if (!this.cartId) {
            const res = await fetch('/backend/servicio/shopping-cart/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCookie('csrftoken')
                },
                body: JSON.stringify({ items: [] })
            });
            const data = await res.json();
            this.cartId = data.cart.id;
            this.setup(data.cart);
        }
        else {
            const res = await fetch(`/backend/servicio/shopping-cart/${this.cartId}/`);
            const data = await res.json();
            this.setup(data.cart);
        }
    }
    setup(params) {
        this.shippingCost = params.shippingCost;
        this.billing = params.billing;
        this.adviser = params.adviser;
        this.dispatch = params.dispatch;
        this.parts = params.body.parts || [];
        this.accessories = params.body.accessories || [];
        this.services = params.body.services || [];
        this.revisions = params.body.revisions || [];
        this.plans = params.body.plans || [];
        this.placa = params.body.placa || '';
        this.setBadge();
    }
    setBadge() {
        const el = document.getElementById('cart-badge');
        if (el) {
            if (this.totalProducts > 0) {
                const c = document.createElement('div');
                c.setAttribute('class', 'cart-badge');
                const s = document.createElement('span');
                s.setAttribute('class', 'white');
                s.textContent = `${this.totalProducts}`;
                c.appendChild(s);
                el.appendChild(c);
            }
        }
    }
    get partsWithDelivery() {
        return this.parts ? this.parts.filter((item) => item.item.delivery) : [];
    }
    get partsWithoutDelivery() {
        return this.parts ? this.parts.filter((item) => !item.item.delivery) : [];
    }
    get accessoriesToInstall() {
        return this.accessories ? this.accessories.filter((item) => !!item.installation) : [];
    }
    get accessoriesToDelivery() {
        return this.accessories.filter((item) => !item.installation);
    }
    get toDelivery() {
        return (this.partsWithDelivery.length + this.accessoriesToDelivery.length) > 0;
    }
    get share() {
        return `${window.origin}/compartir-carrito/${cart.cartId}`;
    }
    addPart(item) {
        const find = this.parts.find(s => s.item.reference === item.item.reference);
        if (find) {
            find.quantity += 1;
        }
        else {
            this.parts.push(item);
        }
    }
    addAccessory(item) {
        const find = this.accessories.find(s => s.item.reference === item.item.reference);
        if (find) {
            find.quantity += 1;
        }
        else {
            this.accessories.push(item);
        }
    }
    addService(item) {
        const find = this.services.find(s => s.item.id === item.item.id);
        if (find) {
            find.quantity += 1;
        }
        else {
            this.services.push(item);
        }
    }
    addRevision(item) {
        const find = this.revisions.find(s => s.item.reference === item.item.reference);
        if (find) {
            find.quantity = 1;
        }
        else {
            this.revisions.push(item);
        }
    }
    addPlan(item) {
        const find = this.plans.find(s => s.item.reference === item.item.reference);
        if (find) {
            find.quantity = 1;
        }
        else {
            this.plans.push(item);
        }
    }
    get subtotal() {
        let sum = 0;
        try {
            this.parts.forEach((s) => sum += (s.quantity * s.price));
            this.accessories.forEach((s) => sum += (s.quantity * s.price));
            this.services.forEach((s) => sum += (s.quantity * s.price));
            this.revisions.forEach((s) => sum += (s.quantity * s.price));
            this.plans.forEach((s) => sum += (s.quantity * s.price));
        }
        catch (e) {
            console.error('Cart not initialized.');
        }
        return sum;
    }
    get total() {
        return this.subtotal + this.shippingCost;
    }
    get count() {
        return this.parts.length + this.accessories.length + this.services.length + this.revisions.length + this.plans.length;
    }
    get totalProducts() {
        let t = 0;
        this.parts.forEach((s) => {
            t += s.quantity;
        });
        this.accessories.forEach((s) => {
            t += s.quantity;
        });
        this.services.forEach((s) => {
            t += s.quantity;
        });
        this.revisions.forEach((s) => {
            t += s.quantity;
        });
        this.plans.forEach((s) => {
            t += s.quantity;
        });
        return t;
    }
    removePart(item) {
        const index = this.parts.findIndex(s => s.item.id === item.item.id);
        if (index >= 0 && index < this.parts.length) {
            this.parts.splice(index, 1);
            return true;
        }
        return false;
    }
    removeAccessory(item) {
        const index = this.accessories.findIndex(s => s.item.reference === item.item.reference);
        if (index >= 0 && index < this.accessories.length) {
            this.accessories.splice(index, 1);
            return true;
        }
        return false;
    }
    refreshPlaca() {
        const count = this.revisions.length + this.services.length + this.plans.length;
        if (count < 1) {
            this.placa = '';
        }
    }
    removeService(item) {
        const index = this.services.findIndex(s => s.item.id === item.item.id);
        if (index >= 0 && index < this.services.length) {
            this.services.splice(index, 1);
            this.refreshPlaca();
            return true;
        }
        return false;
    }
    removeRevision(item) {
        const index = this.revisions.findIndex(s => s.item.reference === item.item.reference);
        if (index >= 0 && index < this.revisions.length) {
            this.revisions.splice(index, 1);
            this.refreshPlaca();
            return true;
        }
        return false;
    }
    removePlan(item) {
        const index = this.plans.findIndex(s => s.item.reference === item.item.reference);
        if (index >= 0 && index < this.plans.length) {
            this.plans.splice(index, 1);
            this.refreshPlaca();
            return true;
        }
        return false;
    }
    get vinAccessories() {
        return this.accessories.every(a => !!a.vin);
    }
    get toSchedule() {
        return (this.accessoriesToInstall.length + this.services.length + this.revisions.length) > 0;
    }
    get needSchedule() {
        return (this.accessories.filter(a => !!a.installation && !a.byOrder).length + this.services.length + this.revisions.length) > 0;
    }
    toJSON() {
        return {
            id: this.cartId,
            body: {
                parts: this.parts,
                accessories: this.accessories,
                services: this.services,
                revisions: this.revisions,
                plans: this.plans,
                placa: this.placa
            },
            billing: this.billing,
            dispatch: this.dispatch,
            shippingCost: this.shippingCost,
            adviser: this.adviser
        };
    }
    async update(setup = true) {
        const { cart } = await fetch(`/backend/servicio/shopping-cart/${this.cartId}/`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCookie('csrftoken')
            },
            body: JSON.stringify(this.toJSON())
        }).then(r => r.json());
        if (setup) {
            this.setup(cart);
        }
    }
    get updatePrices() {
        const cityID = this.dispatch && this.dispatch.address ? this.dispatch.address.city.id : undefined;
        const cityService = this.dispatch && this.dispatch.schedule ? this.dispatch.schedule.ciudad : undefined;
        return {
            parts: this.parts.map((item) => {
                return {
                    codReferencia: item.item.reference,
                    tipo: item.item.type,
                    ciudad: cityID,
                    modeloTasa: item.item.codModelo,
                    incluyeInstalacion: '1',
                };
            }),
            accessories: this.accessories.map((item) => {
                return {
                    codReferencia: item.item.reference,
                    tipo: item.item.type,
                    ciudad: item.installation ? cityService : cityID,
                    modeloTasa: item.item.codModelo,
                    incluyeInstalacion: item.installation ? '1' : '0'
                };
            }),
            services: this.services.map((item) => {
                return {
                    codReferencia: item.item.reference,
                    tipo: item.item.type || 'Z',
                    ciudad: cityService,
                    modeloTasa: item.item.codModeloTasa,
                    incluyeInstalacion: '1'
                };
            }),
            revisions: this.revisions.map((item) => {
                return {
                    vin: item.item.vin,
                    kilometraje: item.item.km,
                    ciudad: cityService
                };
            }),
            plans: this.plans.map((item) => {
                return {
                    reference: item.item.reference,
                    vin: item.item.vin,
                    kilometraje: item.item.km,
                    ciudad: cityService ? cityService : item.city.id
                };
            }),
            dispatch: this.toJSON().dispatch
        };
    }
    async checkPrices() {
        try {
            const { cart, items, error, messages } = await fetch(`/backend/servicio/check-prices/${this.cartId}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCookie('csrftoken')
                },
                body: JSON.stringify(this.updatePrices)
            }).then(r => r.json());
            this.setup(cart);
            this.confirmed = !error;
            let el = null;
            if (messages.length > 0) {
                el = document.createElement('div');
                const ul = document.createElement('div');
                messages.forEach((m) => {
                    const il = document.createElement('li');
                    il.textContent = m;
                    ul.appendChild(il);
                });
                el.appendChild(ul);
            }
            return {
                error,
                items,
                messages,
                el
            };
        }
        catch (e) {
            console.error(e);
            return {
                error: true,
                messages: ['Se presento un error de servidor'],
                items: []
            };
        }
    }
    async confirmPrices(data) {
        const { cart, notAvailable, body } = await fetch(`/backend/servicio/confirm-prices/${this.cartId}/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCookie('csrftoken')
            },
            body: data ? JSON.stringify(data) : undefined
        }).then(r => r.json());
        this.setup(cart);
        return (notAvailable === null || notAvailable === void 0 ? void 0 : notAvailable.length) > 0 ? body : null;
    }
    async createOrder() {
        const { order } = await fetch('/backend/servicio/create-order/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCookie('csrftoken')
            },
            body: JSON.stringify({
                cart_id: this.cartId
            })
        }).then((r) => r.json());
        return order;
    }
    async updateInstallation(params) {
        const { cart } = await this.request({
            url: `/backend/servicio/instalacion-paquetes/${this.cartId}/`,
            method: 'POST',
            params
        });
        this.setup(cart);
        return this;
    }
    request(data) {
        const { url, method, params } = data;
        return new Promise((resolve, reject) => {
            fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCookie('csrftoken')
                },
                body: JSON.stringify(params)
            }).then((response) => {
                if (response.ok) {
                    response.json().then((data) => {
                        resolve(data);
                    }).catch((e) => {
                        reject(e);
                    });
                }
                else {
                    response.json().then((body) => {
                        reject(body);
                    }).catch(() => {
                        reject();
                    });
                }
            }).catch((e) => {
                reject(e);
            });
        });
    }
    async updateVehicle(vehicle) {
        this.parts.forEach(p => {
            p.item.codModelo = vehicle.codModeloTASA;
        });
        this.accessories.forEach(a => {
            a.vin = vehicle.vin;
            a.placa = vehicle.placa;
            a.item.codModelo = vehicle.codModeloTASA;
        });
        this.services.forEach(s => {
            s.item.vin = vehicle.vin;
            s.item.codModeloTasa = vehicle.codModeloTASA;
        });
        this.plans.forEach(p => {
            p.item.vin = vehicle.vin;
            p.item.codModeloTasa = vehicle.codModeloTASA;
        });
        this.revisions.forEach(r => {
            r.item.vin = vehicle.vin;
            r.item.codModeloTasa = vehicle.codModeloTASA;
        });
        this.placa = vehicle.placa;
        await this.update(true);
        return this.confirmPrices({ city: `${getSelectedCity()}` });
    }
    async updateCity(cityId) {
        this.parts.forEach(p => {
            p.city = { id: `${cityId}` };
        });
        this.accessories.forEach(a => {
            a.city = { id: `${cityId}` };
        });
        this.services.forEach(s => {
            s.city = { id: `${cityId}` };
        });
        this.revisions.forEach(r => {
            r.city = { id: `${cityId}` };
        });
        this.plans.forEach(p => {
            p.city = { id: `${cityId}` };
        });
        await this.update(true);
        return this.confirmPrices({ city: `${cityId}` });
    }
}
let cart;
export function getCart() {
    return new Promise(async (resolve) => {
        if (!cart) {
            cart = new Cart();
            await cart.init();
        }
        resolve(cart);
    });
}
